import React from "react";

export default function Contact() {
  return (
    <article>
      <h2 id="contact">Let's get in touch.</h2>
      <p>
        We welcome you to join us on{" "}
        <a href="https://bit.ly/hd-whats">WhatsApp</a>{" "}
        {"&"} <a href="https://www.facebook.com/groups/haifadev/">Facebook</a>,
        and follow our meetup announcements as member of our{" "}
        <a href="https://www.meetup.com/Haifa-dev/">Meetup group</a>.
      </p>
      <p>
        We've also got a thriving <a href="https://discord.gg/AgVSmeHdh7">Discord community</a> where 
        you can ask any question in any software-related topic and receive professional help via either chat or voice calls.
      </p>
    </article>
  );
}
